const RechargeList = () => import('@/pages/recharge-manage/RechargeList');
const RechargeRecords = () => import('@/pages/recharge-manage/RechargeRecords');


export default[
    {
      path: '/recharge-list',
      component: RechargeList,
      meta: [
        {
          name: '充值管理',
          url: '',
        },
        {
          name: '充值列表',
          url: '',
        },
      ],
    },
    {
      path: '/recharge-records',
      component: RechargeRecords,
      meta: [
        {
          name: '充值管理',
          url: '/recharge-list',
        },
        {
          name: '充值记录',
          url: '',
        }
      ],
    },
]
